<template>
    <div class="clearfix main_center" >
        <div class="top-content">
            <div class="left-navbar">
                <!--<el-button type="primary" size="small" plain style="margin-right:10px;" @click="routerEdit()">编辑</el-button>-->
                <el-button size="small" @click="backBtn">返回</el-button>
            </div>
        </div>
        <div class="right-content">
            <el-form ref="form" :model="form" label-width="150px" class="form viewFormWrapper">
                <el-card class="box-card" :style="{'height':cardHight}" >
                    <div slot="header" class="clearfix">
                        <span>门禁出入记录</span>
                    </div>
            <!--<el-row>
                        <el-col :span="12">
                            <el-form-item label="名称：">
                                <span>{{form.name }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="流id：">
                                <span>{{form.streamId }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                             <el-form-item label="流媒体地址：">
                                <span>{{form.streamUrl }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="发布标记：" >
                               <span>{{form.pubFlag==0?"未发布":"已发布"}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>-->
                  <div style="display: inline-flex;">
                    <img  style="width: 150px;height: 191px;"> <!--:src="item.imgUrl"-->
                    <div style="width: 400px;display: inline-block;margin-left: 20px;">
                      <p>
                        <span  style="font-size: 35px">{{ form.personName }}</span>
                        <span style="margin-left: 20px;">{{ form.personRoleName }}</span>
                        <span style="margin-left: 20px;font-size: 25px">【{{ form.inoutFlagName }}】</span>
                      </p>
                      <p><span >{{form.idcard}}</span></p>
                      <p><span>发生门禁：</span><span >{{form.guardName}}</span></p>
                      <p><span>发生时间：</span><span >{{form.createTime}}</span></p>
                      <p><span>人员体温：</span><span >{{form.personTemp}}</span></p>
                    </div>
                  </div>
                </el-card>
            </el-form>
        </div>
        

    </div>
</template>

<script>

import { mapState } from "vuex";
// import {tabsCloseCurrentHandle} from '@/utils/routeTab';
export default {
     components: {

    },
    data(){     
        return{
            cardHight:(document.documentElement.clientHeight -116) + 'px',
            form:{
              id:'',
              personName: '',//姓名
              personRole: '', //角色
              idcard: '',//身份证号
              inoutFlag: '',//进出标记 1进 2出 3非法
              guardId:'',
              personTemp:'',
              guardName:'',
              personRoleName:'',
              inoutFlagName:'',
            },
            id:'', //点击提交的时候也传id
        }
    },
    computed: {
        ...mapState({
                stateData:state=>state.user
        })
    },
    activated(){

        this.id = window.sessionStorage.getItem("id")
        this.getDataById()

    },
    methods:{

        backBtn(){ //返回
          tabsCloseCurrentHandle();
            this.$router.push({
                name:'guard_witness_list'
            })
            this.$refs.form.resetFields();
        },
        getDataById(){ //详情

            if(this.id != ""){

                this.$httpReq.get('/guardWitness/get?id='+this.id).then(res=>{
                    if(res.data.code == '1'){
                      this.form={...res.data.data};
                    }
                })

            }
        },

    }



}
</script>

<style lang="scss" scoped>

</style>